import React from 'react';

export const API = '/api/modportal';

export const C = {
  primary: '#0F6E56', primaryBg: '#E1F5EE', border: '#E3E1D9',
  text: '#1F1E1B', muted: '#5F5E5A', surface: '#F7F5F0',
  gold: '#91600C', danger: '#C0392B', purple: '#9B59B6', blue: '#2563eb',
};

export function authHeaders() {
  const t = localStorage.getItem('token') || '';
  return { 'Content-Type': 'application/json', ...(t ? { Authorization: `Token ${t}` } : {}) };
}

export function ago(iso) {
  if (!iso) return 'never';
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 300) return 'just now';
  if (s < 3600) return Math.floor(s / 60) + 'm ago';
  if (s < 86400) return Math.floor(s / 3600) + 'h ago';
  const d = Math.floor(s / 86400);
  return d < 30 ? d + 'd ago' : Math.floor(d / 30) + 'mo ago';
}

export function when(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return d.getDate() + '-' + M[d.getMonth()] + '-' + String(d.getFullYear()).slice(2);
}

export const btn = {
  fontSize: 12, padding: '6px 12px', border: '1px solid ' + C.border,
  borderRadius: 7, background: '#fff', cursor: 'pointer', color: C.muted,
};

export const btnMain = {
  fontSize: 12, padding: '6px 12px', borderRadius: 7, cursor: 'pointer',
  background: C.primary, color: '#fff', border: '1px solid ' + C.primary, fontWeight: 700,
};

export const inp = {
  width: '100%', padding: '8px 11px', fontSize: 13,
  border: '1px solid ' + C.border, borderRadius: 7,
  boxSizing: 'border-box', marginBottom: 8,
};

export function Flag({ code, size }) {
  const s = size || 16;
  if (!code || code.length !== 2) return null;
  return (
    <img
      src={'https://flagcdn.com/w40/' + code.toLowerCase() + '.png'}
      alt={code} width={s} height={Math.round(s * 0.75)} loading="lazy"
      style={{ borderRadius: 2, verticalAlign: 'middle', objectFit: 'cover' }}
    />
  );
}

export function LevelBadge({ level }) {
  const mega = level === 'mega';
  return (
    <span style={{
      fontSize: 9.5, fontWeight: 700, padding: '1px 7px', borderRadius: 9,
      background: mega ? '#F3E5F5' : C.primaryBg,
      color: mega ? C.purple : C.primary, whiteSpace: 'nowrap',
    }}>
      {mega ? 'MEGA MOD' : 'MOD'}
    </span>
  );
}

export function StatusDot({ status }) {
  const col = status === 'active' ? '#2ECC71' : status === 'inactive' ? C.gold : '#B4B2A9';
  return (
    <span style={{
      display: 'inline-block', width: 7, height: 7,
      borderRadius: 4, background: col, marginRight: 5,
    }} />
  );
}
